// import { countTransactionTypesPerDayOfWeek } from "./transactionChartUtils";

export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  // header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // data rows
  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

export function exportTotalTransactionsByDayCSV(
  transactionCounts,
  storeName,
  range,
  fileName = "TotalTransactionsByDay.csv"
) {
  // Count transactions per day of week
  const counts = transactionCounts;

  // Days of week labels Sun-Sat
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // Build CSV rows
  const data = days.map((day, idx) => ({
    Brand: "Angels Pizza",
    Store: storeName || "All Stores",
    DateRange: `${range.tran_date.$lte.split("T")[0]} ${
      range.tran_date.$gte.split("T")[0]
    }`,
    Day: day,
    DineIn: counts.DineIn[idx] || 0,
    GrabFood: counts.GrabFood[idx] || 0,
    TakeOut: counts.TakeOut[idx] || 0,
    Delivery: counts.Delivery[idx] || 0,
    DriveThru: counts.Drive[idx] || 0,
    FoodPanda: counts.FoodPanda[idx] || 0,
  }));

  // Convert to CSV and download
  const csvString = convertToCSV(data);
  if (!csvString) {
    console.warn("No data to export");
    return;
  }
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
